import cn from 'classnames';
import { Link, LinkProps } from 'react-router-dom';

interface ButtonProps {
  outline?: boolean;
  loading?: boolean;
}

const buttonClasses = (className?: string, outline?: boolean, disabled?: boolean) =>
  cn(
    'inline-flex items-center px-4 py-2 border border-white shadow-sm text-base font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
    className,
    {
      'border border-blue-500 text-blue-500': outline && !disabled,
      'border-gray-500 text-gray-500 text-gray-500 cursor-not-allowed': outline && disabled,
      'bg-blue-500 text-white': !outline && !disabled,
      'bg-gray-500 text-white cursor-not-allowed': !outline && disabled,
    },
  );

export function Button({
  className,
  children,
  outline,
  loading = false,
  disabled,
  ...props
}: ButtonProps &
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
  return (
    // eslint-disable-next-line react/button-has-type
    <button {...props} disabled={disabled} className={buttonClasses(className, outline, disabled)}>
      {loading ? 'Loading ...' : children}
    </button>
  );
}

export function ButtonLink<S>({
  children,
  outline,
  className,
  ...props
}: ButtonProps & LinkProps<S> & React.RefAttributes<HTMLAnchorElement>) {
  return (
    <Link {...props} className={buttonClasses(className, outline)}>
      {children}
    </Link>
  );
}
